import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="text-black pt-12 pb-6 bg-gray-100">
      <div className="container mx-auto px-6 text-center md:text-left">
        {/* ===== Newsletter Section ===== */}
        <div className="mb-12 mx-auto justiy-center items-center text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-3 text-black">
            Stay in the Loop
          </h2>
          <p className="text-black mb-6">
            Subscribe to our newsletter for exclusive offers and new arrivals.
          </p>
          <Link to={"/newsletter"}>
            <button
              type="submit"
              className="bg-[#fe7590] hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-full transition-all cursor-pointer hover:-translate-y-1"
            >
              Subscribe
            </button>
          </Link>
        </div>

        {/* ===== Footer Links ===== */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8 text-center">
          {/* Shop */}
          <div>
            <h4 className="text-black font-semibold mb-4">Home Essentials</h4>
            <ul className="space-y-2 ">
              <li>
                <Link
                  to="/categories/HomeDecor"
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Home Decor
                </Link>
              </li>

              <li>
                <Link
                  to={"/categories/HomeSecurity"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-  125"
                >
                  Home Security
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/HomeAppliances"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Home Appliances
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/Furniture"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Furniture & Mattresses
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-black font-semibold mb-4">Personal Care</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to={"/categories/SkinCare"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Skin Care
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/HairCare"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Hair Care
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/Wellness"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Wellness
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/WeightLoss"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  WeightLoss
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-black font-semibold mb-4">Other Categories</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to={"/categories/GiftCards"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  GiftCards
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/PetsCare"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Pets Care
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/FireSafety"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Fire Safety
                </Link>
              </li>
              <li>
                <Link
                  to={"/categories/FoodBeverages"}
                  className="transform transition duration-300 hover:text-[#fe7590] hover:scale-125"
                >
                  Food & Beverages
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-black font-semibold mb-4">Help</h4>
            <ul className="space-y-2">
              <li>
                <Link to={"/about"} className="hover:text-[#fe7590]  gap-2">
                  <i className="fab fa-facebook"></i> About
                </Link>
              </li>
              <li>
                <Link to={"/blog"} className="hover:text-[#fe7590]  gap-2">
                  <i className="fab fa-instagram"></i> Blogs
                </Link>
              </li>
              <li>
                <Link to={"/contact"} className="hover:text-[#fe7590]  gap-2">
                  <i className="fab fa-twitter"></i> Contact
                </Link>
              </li>

              <li>
                <Link to={"/faqs"} className="hover:text-[#fe7590]  gap-2">
                  <i className="fab fa-pinterest"></i> FAQ's
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* ===== Copyright ===== */}
        <div className="bg-black text-white rounded-xl border-t border-gray-700 py-4">
          <div className="max-w-[1000px] mx-auto flex flex-col sm:flex-row justify-between items-center px-4 text-sm space-y-3 sm:space-y-0">
            {/* Left Side */}
            <div className="text-center sm:text-left">
              © 2025 <span className="font-semibold text-[#fe7590]">Pure Clean Shopping</span>
              . All Rights Reserved.
            </div>

            {/* Right Side */}
            <ul className="flex flex-wrap justify-center sm:justify-end gap-4">
              <Link to={"/terms"}>
                <li className="hover:text-[#fe7590]  cursor-pointer transition">
                  Terms & Conditions
                </li>
              </Link>
              <Link to={"/privacy_policy"}>
                <li className="hover:text-[#fe7590] cursor-pointer transition">
                  Privacy Policy
                </li>
              </Link>
              <Link to={"/return_refund"}>
                <li className="hover:text-[#fe7590] cursor-pointer transition">
                  Return & Refund
                </li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
